module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-005"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XIX",
      "role": "doc-pagebreak",
      "title": "XIX"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Author’s Note on Sources")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("S")]), _c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TYLE AND ABBREVIATIONS")])]), _vm._v(" generally follow the guidelines of "), _c('i', [_vm._v("The SBL Handbook of Style")]), _vm._v(" (2nd ed.). Unless otherwise noted, English Bible citations are from the ESV, which I occasionally alter (with notice). The Greek text I am using is the NA28. For convenience, I will refer to Old Testament passages by their English chapter and verse numbers. Translations of Old Testament pseudepigrapha are from James H. Charlesworth, ed., "), _c('i', [_vm._v("The Old Testament Pseudepigrapha")]), _vm._v(", 2 vols. (Peabody, MA: Hendrickson, 1983). I give English titles and abbreviations of patristic works not dictated by "), _c('i', [_vm._v("The SBL Handbook of Style")]), _vm._v(". For patristic sources throughout, I have tried to consult the most recent critical editions, as well as the most recent English translations. In addition, I frequently supply references to the "), _c('i', [_vm._v("ANF")]), _vm._v(" and "), _c('i', [_vm._v("NPNF")]), _vm._v(" series to provide convenient access for non-specialist readers. For each initial reference to a volume in the Fathers of the Church series, I provide full bibliographic information; thereafter, I refer to FC with volume and page numbers. When citing older English translations (such as "), _c('i', [_vm._v("ANF")]), _vm._v(" and "), _c('i', [_vm._v("NPNF")]), _vm._v("), I modernize capitalization and usage. Translations of the commentaries on Hebrews by Cyril of Alexandria and John of Damascus are my own, as are translations of modern secondary sources.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31094265","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre6.vue
// module id = 75
// module chunks = 0